import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dropdown from '../../../../elements/Form/dropdown'
import { useExperimentApi } from '../../../../store/api/hooks/experimentApiHook'
import { ErrorResponse, SuccessResponse } from '../../../../store/api/apiTypes'
import { useUserSelector } from '../../../../store/selectors/userSelector'
import Text from '../../../../elements/Typo/Text'
import Icon from '../../../../components/icons'
import Loader from '../../../../components/loader'
import { copyToClipboard } from '../../../../_common/functions'
import toast from 'react-hot-toast'
import CommonInputText from '../../../../components/commonInputText'
interface Props {
    checktruncate?: string
}
const ZoneDesignTablesAccordians: React.FC<Props> = ({ checktruncate }) => {
    const { t } = useTranslation()
    const user: any = useUserSelector()
    const experimentApi = useExperimentApi()
    const [designTables, setDesignTables] = useState<any[]>([])
    const [zones, setZones] = useState<any[] | null>(null)
    const [zone, setZone] = useState<any>(null)
    const [filter, setFilter] = useState('')

    const getZoneDesignData = () => {
        experimentApi.getzonedesign(
            {
                zone: zone.zone_literal, //'zone_001',
            },
            (resp: SuccessResponse<[]>) => {
                setDesignTables(resp.data.map((details: any) => ({ ...details, columns: [], isExpanded: false })))
            },
            (error: ErrorResponse<[]>) => {
                console.log(error)
            },
        )
    }

    const getTableColumnDetails = (table: any, index: number) => {
        const tables: any[] = structuredClone(designTables)

        tables.splice(index, 1, {
            ...designTables[index],
            isExpanded: !designTables[index]['isExpanded'],
        })

        setDesignTables(tables)

        if (!table.columns.length) {
            experimentApi.getZoneDesignDetail(
                {
                    table_name: table.name,
                },
                (resp: any) => {
                    const tables: any[] = structuredClone(designTables)

                    tables.splice(index, 1, {
                        ...designTables[index],
                        isExpanded: true,
                        columns: resp.data,
                    })

                    setDesignTables(tables)
                },
                (error: ErrorResponse<[]>) => {
                    console.log(error)
                },
            )
        }
    }

    const onZoneChange = (e: any) => {
        setZone(e)
    }

    useEffect(() => {
        if (user) {
            const sortedZones = user?.zones ? [...user.zones].sort((a: any, b: any) => a.title.localeCompare(b.title)) : []
            setZones(
                sortedZones.map((zone: any) => ({
                    ...zone,
                    label: zone.title,
                    value: zone.zone_literal,
                })),
            )
        }
    }, [user])

    useEffect(() => {
        if (zones) {
            setZone(zones[0])
        }
    }, [zones])

    useEffect(() => {
        if (zone) {
            getZoneDesignData()
        }
    }, [zone])

    return (
        <div className="w-full">
            <div className="flex items-center justify-between mb-2" data-testid="zone-select-wrapper">
                <p className="text-[#0F0F0F] !text-[0.75rem] !mb-0 leading-6 font-bold">{t('Select Data from existing tables')}</p>
                <Dropdown value={zone} onChange={onZoneChange} options={zones || []} data-testid="zone-dropdown" />
            </div>
            <CommonInputText value={filter} onChange={(e: any) => setFilter(e.target.value)} placeholder={t('Filter tables by name...')} data-testid="table-filter-input" />
            <div className="shadow-1 rounded-[0.833rem] p-2 h-[14rem] overflow-auto mt-2" data-testid="table-list">
                <div data-testid="table-list">
                    {designTables?.map((table, index) => {
                        if (table?.name?.toLowerCase().includes(filter ? filter.toLowerCase() : '')) {
                            return (
                                <div data-testid={`table-row-${index}`} key={`table-${table?.name}-${index}`} className="bg-[#f9f9f9] border border-[#e4e4e4] rounded-[0.25rem] my-3">
                                    <button
                                        type="button"
                                        className="flex items-center justify-between p-1 gap-1 min-h-0 !min-w-0 max-w-full cursor-pointer"
                                        onClick={() => {
                                            getTableColumnDetails(table, index)
                                            void copyToClipboard(table?.name)
                                            toast(t('Table name copied!'))
                                        }}
                                    >
                                        <div className="flex items-center justify-between gap-1 ">
                                            <Icon size={table.isExpanded ? '1.6' : '1'} name={table.isExpanded ? 'down' : 'arrow-right'} />
                                            <Text size="md" className={`${checktruncate === '1' ? '' : 'truncate'} cursor-pointer`}>
                                                {table?.name}
                                            </Text>
                                        </div>
                                        <div className="rounded-[0.333rem] p-2 bg-[#f4f4f4] flex-shrink-0">
                                            <Text size="sm" className="whitespace-nowrap">
                                                {table?.alias}
                                            </Text>
                                        </div>
                                    </button>
                                    {table.isExpanded ? (
                                        <div className="px-5">
                                            {table?.columns.length ? (
                                                table?.columns.map((column: any, i: any) => (
                                                    <div data-testid={`table-${index}-col-${i}`} key={`col-${column?.col_name}-${i}`} className="">
                                                        <div className="h-10 flex items-center justify-between border-b border-[#e4e4e4]">
                                                            <div className="flex items-center gap-3 text-black">
                                                                <Icon name="bell" size={0.8} className="p-1 rounded-[0.3rem] bg-primary" />
                                                                <Text
                                                                    size="md"
                                                                    className="cursor-pointer"
                                                                    onClick={() => {
                                                                        void copyToClipboard(column?.col_name)
                                                                        toast(t('Column name copied!'))
                                                                    }}
                                                                >
                                                                    {column?.col_name}
                                                                </Text>
                                                            </div>
                                                            <div></div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <Loader />
                                            )}
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            )
                        }
                    })}
                </div>
            </div>
        </div>
    )
}

export default ZoneDesignTablesAccordians
